/* eslint-disable no-console,jsx-a11y/anchor-is-valid,no-unused-vars,max-len,no-undef */
import React from 'react';
import './style.scss';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import { useAuthState } from 'react-firebase-hooks/auth';
import firebase from 'firebase';
import axios from 'axios';
import BasketIcon from '../../images/icons/basket-icon.svg';
import getCartTotalQuantity from '../ShoppingCart/getCartTotalQuantity';
import ShoppingCartContext from '../ShoppingCart/shopping-cart-context';
import ShoppingCartQuickViewContext from '../ShoppingCart/ShoppingCartQuickView/shopping-cart-quick-view-context';
import { logout } from '../../utils/firebaseAuth';
import getCloudinary from '../../utils/getCloudinary';
import getIsWholesaleAccount from '../../utils/getIsWholesaleAccount';

let sticky;
let content;
let origOffsetY;
let lastScrollTop = 0;
let hoveringScrollbarActive = false;
const capitilise = str => (str
    ? (
        str.split(' ')
            .map(w => w[0].toUpperCase() + w.substr(1).toLowerCase())
            .join(' ')
    )
    : str);

const NavBar = ({ showSmallLogo }) => {
    const { cart } = React.useContext(ShoppingCartContext);
    const { toggleCartQuickView } = React.useContext(ShoppingCartQuickViewContext);
    // eslint-disable-next-line no-unused-vars
    const [authUser, initialising, error] = typeof window !== 'undefined' ? useAuthState(firebase.auth()) : Array(3);
    const [isWholesaleAccount, setIsWholesaleAccount] = React.useState(false);
    // const forceUpdate = useForceUpdate();
    console.log('authUser', authUser);
    React.useEffect(() => {
        if (authUser && !initialising && !isWholesaleAccount) {
            getIsWholesaleAccount()
                .then((wholesaleResult) => {
                    setIsWholesaleAccount(wholesaleResult);
                });
        }
    }, [axios.interceptors.request.handlers.length]);

    React.useEffect(() => {
        // eslint-disable-next-line no-undef,no-undef
        sticky = document.querySelector('.navbar'); // sets .nav element as a JS variable:
        // eslint-disable-next-line no-undef
        content = document.querySelector('.nav-bar-below-content');
        // sets var equal to height in pixels to top of page from element (sticky):

        origOffsetY = sticky.offsetTop;

        const scrollEvent = () => {
            console.log('window.pageYOffset', window.pageYOffset);
            console.log('origOffsetY', origOffsetY);
            // eslint-disable-next-line no-undef,no-unused-expressions
            if (window.pageYOffset > origOffsetY + 70) {
                // eslint-disable-next-line no-undef
                if (lastScrollTop > window.pageYOffset) {
                    console.log('up');


                    if (hoveringScrollbarActive && sticky.classList.contains('no-animation-navbar-initial')) {
                        sticky.classList.remove('no-animation-navbar-initial');
                    }

                    if (!sticky.classList.contains('navbar-fixed-top')) {
                        console.log('adding');
                        sticky.classList.add('navbar-fixed-top');
                        sticky.classList.remove('is-hidden-fixed-top');
                    }
                } else if (lastScrollTop < window.pageYOffset) {
                    console.log('down');
                    if (!sticky.classList.contains('is-hidden-fixed-top')) {
                        console.log('adding');
                        if (!hoveringScrollbarActive && !sticky.classList.contains('no-animation-navbar-initial')) {
                            sticky.classList.add('no-animation-navbar-initial');
                            hoveringScrollbarActive = true;
                        }
                        sticky.classList.add('is-hidden-fixed-top');
                        sticky.classList.remove('navbar-fixed-top');
                    }
                }
            } else if (window.pageYOffset < origOffsetY) {
                hoveringScrollbarActive = false;
                sticky.classList.remove('navbar-fixed-top', 'is-hidden-fixed-top', 'no-animation-navbar-initial');
            }


            // eslint-disable-next-line no-undef
            if (lastScrollTop <= window.pageYOffset) {
                // sticky.classList.add('is-hidden-fixed-top');
            }

            // adds padding to container for
            // seamless transition as nav is switched to fixed:
            // eslint-disable-next-line no-undef,no-unused-expressions
            window.pageYOffset >= origOffsetY && lastScrollTop > window.pageYOffset ? content.classList.add('nav-padding')
                : content.classList.remove('nav-padding');

            // eslint-disable-next-line no-undef
            lastScrollTop = window.pageYOffset;
        };

        if (showSmallLogo) {
            setTimeout(() => {
                sticky.classList.add('navbar-fixed-top');
                content.classList.add('nav-padding');
            });
        } else {
            setTimeout(() => {
                // eslint-disable-next-line no-undef
                document.addEventListener('scroll', scrollEvent);
            }, 1000);
        }

        // Get all "navbar-burger" elements
        // eslint-disable-next-line no-undef
        const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

        // Check if there are any navbar burgers
        if ($navbarBurgers.length > 0) {
            // eslint-disable-next-line no-undef
            const outerWrapper = document.querySelector('.navbar-outer-region-wrapper');
            // Add a click event on each of them
            $navbarBurgers.forEach((el) => {
                el.addEventListener('click', () => {
                    // Get the target from the "data-target" attribute
                    const { target } = el.dataset;
                    // eslint-disable-next-line no-undef
                    const $target = document.getElementById(target);

                    // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
                    el.classList.toggle('is-active');
                    $target.classList.toggle('is-active');
                    outerWrapper.classList.toggle('is-hidden');

                    outerWrapper.addEventListener('click', (outerRegion) => {
                        el.classList.remove('is-active');
                        $target.classList.remove('is-active');
                        outerWrapper.classList.add('is-hidden');
                    });
                });
            });
        }

        // eslint-disable-next-line no-undef
        return () => document.removeEventListener('scroll', scrollEvent);
    }, []);


    return (
        <nav className="navbar" role="navigation" aria-label="main navigation">
            <Link to="/">
                <img
                    src={getCloudinary().url(
                        'dashboard-uploads/dr-watson-emblem_xheylr',
                        { height: 50, crop: 'fit', fetch_format: 'auto' },
                    )}
                    alt="DR WATSON"
                    className="navbar-logo"
                />
            </Link>
            <div className="container">
                <div className="navbar-brand">
                    <CartNavBarItem
                        cart={cart}
                        className="is-hidden-desktop"
                        toggleCartQuickView={toggleCartQuickView}
                    />
                    <a
                        role="button"
                        className="navbar-burger burger"
                        aria-label="menu"
                        aria-expanded="false"
                        data-target="navbarBasicExample"
                    >
                        <span aria-hidden="true" />
                        <span aria-hidden="true" />
                        <span aria-hidden="true" />
                    </a>
                </div>

                <div className="navbar-outer-region-wrapper is-hidden" />
                <div id="navbarBasicExample" className="navbar-menu">
                    <div className="navbar-start">
                        <Link className="navbar-item" to="/">
                            Home
                        </Link>


                        <div className="navbar-item has-dropdown is-hoverable">
                            <Link className="navbar-link" to="shop">
                                Shop
                            </Link>

                            <div className="navbar-dropdown">
                                <Link className="navbar-item" to="cbd-delivery-system-feature">
                                    CBD Delivery System
                                </Link>
                                <Link className="navbar-item" to="pods">
                                    Pods
                                </Link>

                                <Link className="navbar-item" to="e-liquids">
                                    E-Liquids
                                </Link>
                                <Link className="navbar-item" to="skincare">
                                    Skincare
                                    <span className="tag is-theme-info new-tag">New</span>
                                </Link>
                                <Link className="navbar-item" to="supplements">
                                    Supplements
                                    <span className="tag is-theme-info new-tag">NEW</span>
                                </Link>
                            </div>
                        </div>

                        <Link className="navbar-item" to="dr-watson-cbd">
                            DR Watson CBD
                        </Link>

                        <Link className="navbar-item" to="about-cbd">
                            About CBD
                        </Link>

                        <Link className="navbar-item" to="stockists">
                            Stores/Stockists
                        </Link>

                        <Link className="navbar-item" to="certificates">
                            Certificates
                        </Link>

                        {/* <a */}
                        {/*    className="navbar-item" */}
                        {/*    href="https://medium.com/dr-watson" */}
                        {/*    target="_blank" */}
                        {/*    rel="noopener noreferrer" */}
                        {/* > */}
                        {/*    Blog */}
                        {/* </a> */}

                        <Link className="navbar-item" to="contact">
                            Contact
                        </Link>
                    </div>

                    <div className="navbar-end">
                        <div className="navbar-item">
                            {
                                authUser
                                    ? (

                                        <div className="navbar-item has-dropdown is-hoverable">
                                            <a className="navbar-link">
                                                {
                                                    isWholesaleAccount
                                                    && (
                                                        <div className="tag is-success is-medium wholesale-tag">
                                                            Wholesale
                                                            Account
                                                        </div>
                                                    )
                                                }
                                                {`Hi ${capitilise(authUser.isAnonymous ? 'Guest' : authUser.displayName)}`}
                                            </a>

                                            <div className="navbar-dropdown">
                                                <Link className="navbar-item" to="/account/orders">
                                                    My Orders
                                                </Link>
                                                <hr className="navbar-divider" />
                                                <a
                                                    className="navbar-item"
                                                    onClick={logout}
                                                >
                                                    Logout
                                                </a>
                                            </div>
                                        </div>
                                    )
                                    : (
                                        <div className="buttons">
                                            <Link className="button is-theme-info has-text-white has-text-weight-semibold" to="/sign-up">
                                                Sign Up
                                            </Link>
                                            <Link className="button is-primary has-text-weight-semibold" to="/login">
                                                Log in
                                            </Link>
                                        </div>
                                    )
                            }
                        </div>

                        <CartNavBarItem
                            cart={cart}
                            className="is-hidden-touch"
                            toggleCartQuickView={toggleCartQuickView}
                        />
                    </div>
                </div>
            </div>
        </nav>
    );
};

// eslint-disable-next-line react/prop-types
const CartNavBarItem = ({ cart, toggleCartQuickView, className }) => (
    <div
        className={`navbar-item cart-navbar-item ${className}`}
        onClick={() => toggleCartQuickView()}
    >
        <img
            src={BasketIcon}
            alt="Your basket"
            className="basket-image"
        />
        {
            getCartTotalQuantity(cart) > 0
            && (
                <span className="cart-navbar-item__badge">
                    {getCartTotalQuantity(cart)}
                </span>
            )
        }
    </div>
);

CartNavBarItem.propTypes = {
    toggleCartQuickView: PropTypes.func.isRequired,
};

NavBar.defaultProps = {
    showSmallLogo: false,
};


NavBar.propTypes = {
    showSmallLogo: PropTypes.bool,
};

export default NavBar;
